import React, { useEffect, useRef, useState } from 'react'
import './edit-distribute-modal.styles.scss';
import Modal from '@/components/modal/modal.component';
import RewardsForm from '../create-elements/blocks/rewards-form.component';

const EditDistributeModal = ({
    showEditModal,
    cancelModal,
    playerObj,
    gameElements,
    saveIndDistribution,
    disabled,
    gameData
}) => {

    const [ formData, setFormData ] = useState({});
    const dataRef = useRef({});

    useEffect(() => {
        if (!playerObj) return;
        dataRef.current = playerObj.distribution || {};
        setFormData(dataRef.current);
    }, [playerObj, showEditModal]);

    function saveData(key, value) {
        console.log(key, value);
        dataRef.current = {
            ...dataRef.current,
            ...{[key]: value}
        }
        setFormData(dataRef.current);
        console.log(dataRef.current);
    }

    function cancelChanges() {
        dataRef.current = {};
        setFormData({});
        cancelModal();
    }

    function saveChanges() {
        if (!playerObj || !dataRef.current) return;
        saveIndDistribution(playerObj.playerId, dataRef.current);
        cancelModal();
    }
    
    return (
        <div className='edit-distribute-modal'>
            <Modal
                show={showEditModal}
                cancel={cancelModal}
                text={`Edit Distribution for ${playerObj.displayName}`}>
                <div className='modal-children'>
                    <RewardsForm
                        type='distribution' 
                        formData={formData}
                        gameElements={gameElements}
                        saveData={saveData}                        
                        disabled={disabled}
                        playerId={playerObj.playerId}
                        gameData={gameData}
                        review={false}
                        teams={playerObj.distribution.type === 'teamTotals'} />
                </div>
                <hr />
                <div className='buttons'>
                    <button 
                        className='g-button small-btn'
                        onClick={() => cancelChanges()}>
                        Cancel
                    </button>
                    <button 
                        className='g-button med-btn primary'
                        onClick={() => saveChanges()}>
                        Save Changes
                    </button>
                </div>
            </Modal>
        </div>
    )
}

export default EditDistributeModal